import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';

import {environment} from "../../environments/environment";
import {MessagesService} from "../app/services/messages.service";

const RESPONSE = {
  smartSummaryResponse: JSON.stringify({
    "correlation_id": null,
    "status": "Completed",
    "sx_id": "005TG72024000040065",
    "smart_summary_id": "user_testa8@GEN_20250826155142_005TG72024000040065",
    "start_datetime": "2025-08-26T15:51:42.153988Z",
    "end_datetime": "2025-08-26T15:55:01.014604Z",
    "data": [
      {
        "macro_section_id": "Dati dal Sistema",
        "data": [
          {
            "section_id": "SEZIONE 1: Garanzie e polizza",
            "data": [
              {
                "subsection_id": "",
                "attributes": {},
                "data": "Regolarità amministrativa: Sì"
              }
            ]
          },
          {
            "section_id": "SEZIONE 2: Stato del sinistro",
            "data": [
              {
                "subsection_id": "",
                "attributes": {},
                "data": "Tipo sinistro: CARD GESTIONARIO"
              },
              {
                "subsection_id": "",
                "attributes": {},
                "data": "Stato sinistro: CHIUSO"
              },
              {
                "subsection_id": "",
                "attributes": {},
                "data": "Stato Responsabilità ANIA: Definita da accordo nella fase di scambio documentale"
              },
              {
                "subsection_id": "",
                "attributes": {},
                "data": `
              | Nominativo         | Ruolo (Contraente/Conducente/Terzo)                        | Oggetto colpito (Veicolo/cose/persone) | Presenza intervento legale | cod gestore | Targa    | Nominativo patrocinatore | Pagamenti | Riserva Pendente |
              |--------------------|------------------------------------------------------------|----------------------------------------|----------------------------|-------------|----------|-------------------------|-----------|------------------|
              | WANNA,KHAWLA       | CONTRAENTE TRASPORTATO                                     | PERSONA,VEICOLO                       | Sì                         | R7F         | CL747YM  |                         |           |                  |
              | MERLINO,GABRIELE   | CONDUCENTE NON CONTRAENTE                                  | PERSONA                               | Sì                         | R7F         | None     |                         |           |                  |
              | SILIVESTRO,MARITA  | CONDUCENTE CONTRAENTE DELLA CONTROPARTE                    | VEICOLO                               | Sì                         | 033         | DD004XM  |                         |           |                  |
              | SILIVESTRO,MARITA  | CONTRAENTE NON CONDUCENTE DI CONTROPARTE NON TRASPORTATO   | VEICOLO                               | No                         | 993         | DD004XM  |                         |           |                  |
              `,
              },
              {
                "subsection_id": "",
                "attributes": {},
                "data": "Presenza Black Box: N/A<br>Crash rilevato: N/A<br>Coerenza Black Box con Dinamica sx: N/A<br>Indicazione presenza eventuale ricorso o invito alla negoziazione assistita: No<br>Contenzioso incardinato: N/A<br>Incarichi pendenti al momento della sintesi:<br>Nessun incarico pendente rilevato al momento della sintesi<br>"
              }
            ]
          }
        ]
      },
      {
        "macro_section_id": "Evidenze Comuni",
        "data": [
          {
            "section_id": "SEZIONE 3: Evidenze da Documenti Comuni",
            "data": [
              {
                "subsection_id": "",
                "attributes": {
                  "documents": []
                },
                "data": ""
              },
              {
                "subsection_id": "Testimonianze",
                "attributes": {
                  "documents": [
                    {
                      "original_document_type": "testimonianze",
                      "ged_protocol": "GGLMS000000464834513"
                    },
                    {
                      "original_document_type": "testimonianze",
                      "ged_protocol": "GGLMS000000464834514"
                    },
                    {
                      "original_document_type": "testimonianze",
                      "ged_protocol": "GGLMS000000464834526"
                    },
                    {
                      "original_document_type": "testimonianze",
                      "ged_protocol": "GGLMS000000465554362"
                    },
                    {
                      "original_document_type": "testimonianze",
                      "ged_protocol": "GGLMS000000465568639"
                    },
                    {
                      "original_document_type": "testimonianze",
                      "ged_protocol": "GGLMS000000466746353"
                    }
                  ]
                },
                "data": "### Testimonianza 1\n\n- **Testimone**: Francesco Bianco\n\n- Il testimone Francesco Bianco ha redatto il documento il 23/07/2024, riferendo di un sinistro avvenuto il 21/07/2024 alle ore 12:00 a Campomarino (TA), incrocio della strada proveniente da Uggiano Montefusco che si immette sulla Manduria - Maruggio, in contrada Cardinale. La dinamica descritta è: \"La Nissan Micra era ferma in coda per uno Stop, in attesa di dare precedenza. La Lancia Musa è partita di scatto e ha tamponato violentemente il posteriore della Nissan Micra ancora ferma.\". I soggetti coinvolti sono: Gabriele Merlino (targa CL747YM, CONDUCENTE NON CONTRAENTE), WANNA KHAWLA (targa CL747YM, CONTRAENTE TRASPORTATO), SILIVESTRO MARITA (targa DD004XM, CONDUCENTE CONTRAENTE DELLA CONTROPARTE).\n\n### Testimonianza 2\n\n- **Testimone**: Francesco Bianco\n\n- Il testimone Francesco Bianco ha redatto il documento il 23/07/2024, riferendo di un sinistro avvenuto il 21/07/2024 alle ore 12:00 a Campomarino (TA), incrocio strada proveniente da Uggiano Montefusco che si immette sulla Manduria - Maruggio, contrada Cardinale. La dinamica descritta è: \"La Lancia Musa (DD004XM) ha tamponato violentemente il posteriore della Nissan Micra (CL747YM), che era ferma in coda in attesa di dare precedenza.\". I soggetti coinvolti sono: Gabriele Merlino (targa CL747YM, Conducente Nissan Micra), Wanna Khawla (targa CL747YM, Trasportato Nissan Micra), Silivestro Marita (targa DD004XM, Conducente Lancia Musa).\n\n"
              },
              {
                "subsection_id": "",
                "attributes":
                  {
                    "documents":
                      [
                        {
                          "original_document_type": "cai",
                          "ged_protocol": "GGLMS000000464735287"
                        },
                        {
                          "original_document_type": "cai",
                          "ged_protocol": "GGLMS000000464735289"
                        },
                        {
                          "original_document_type": "cai",
                          "ged_protocol": "GGLMS000000464735305"
                        }
                      ]
                  }
                ,
                "data":
                  ""
              }
            ]
          }
        ]
      },
      {
        "macro_section_id":
          "Danneggiato: SILIVESTRO MARITA",
        "data":
          [
            {
              "section_id": "SEZIONE 4: Descrizione del fatto e relative conseguenze",
              "data": [
                {
                  "subsection_id": "Intervento legale",
                  "attributes": {
                    "documents": [
                      {
                        "original_document_type": "intervento_legale",
                        "ged_protocol": "GGLMS000000465681323"
                      }
                    ]
                  },
                  "data": "### Intervento Legale 1\n\n- **Data documento**: 21/07/2024\n- **Avvocato**: Avv. Giuseppe Gallù\n- **Oggetto**: Richiesta risarcimento danni patrimoniali a seguito di sinistro stradale\n- **Contenuto**: L'Avv. Giuseppe Gallù rappresenta Silivestri Marita in una richiesta di risarcimento danni patrimoniali a seguito di un sinistro stradale avvenuto a Uggiano (TA). L'autovettura di Silivestri Marita, ferma su via Per Maruggio, è stata colpita dall'autovettura tg. CL747YM, il cui conducente eseguiva una manovra azzardata di retromarcia. Non ci sono stati feriti né accesso al pronto soccorso. Viene richiesta una somma di denaro per il risarcimento dei danni patrimoniali. I veicoli coinvolti hanno targhe DD004XM e CL747YM. Silivestri Marita è la proprietaria del veicolo assistito ed è assicurata con Prima Ass.ni S.p.A.\n\n"
                }
              ]
            },
            {
              "section_id": "SEZIONE 6: Principali accertamenti effettuati sulla quantificazione dei danni",
              "data": [
                {
                  "subsection_id": "Perizia riscontro",
                  "attributes": {
                    "documents": [
                      {
                        "original_document_type": "perizia_riscontro",
                        "ged_protocol": "GGLMS000000467895682"
                      }
                    ]
                  },
                  "data": `
                    |||
                    |---|---|
                    | **Data incarico** | 31/07/2024 |
                    | **Nominativo** | KHAWLA WANNA |
                    | **Certificato di proprietà** | LIVESTRO MARITA - Via CAP. DE TOMMASO, 13 - 72024 - ORIA - BR  C.Fisc/P.Iva: SLIV/MRT83R70F152V Tel: non fornito |
                    | **Locatario** |  |
                    | **Coerenza del danno con dinamica del sinistro** | si |
                    | **Valore Commerciale** | 2.500,00 |
                    | **Valore Relitto** | 0,00 |
                    | **Tipo veicolo** | LANCIA MUSA (TG) (07/04>06/08<) 1.3MJ 16V (66Kw) Mnv 5p/d/1248cc (MNV-5p-1248 |
                    | **Targa** | CL747YM |
                    | **Immatricolazione** | 21/07/2006 |
                    | **Cifra concordata** | NON CONCORDATO |
                    | **Stato delle riparazioni** | DA INIZIARE |
                    | **Riparazione antieconomica** | No |
                    | **Fermo tecnico** | 0 |
                    | **Importo richiesto** | 0,00 |
                    | **Imponibile** | 0,00 |
                    | **Imponibile + iva** | 0,00 |

                    * **Voci di danno e note:** In allegato le foto del veicolo della cpte che presenta danni nella parte anteriore. Nello specifico si nota la rottura del paraurti anteriore, della griglia anteriore inferiore e della modanatura anteriore. Il cofano anteriore è bloccato, non si apre. In merito alla dinamica la cpte ha riferito di non aver tamponato il veicolo garantito ma che è stato quest'ultimo a urtare il suo in manovra di retromarcia. Pertanto, tramite il proprio legale di fiducia, ha inoltrato richiesta danni alla propria compagnia di assicurazioni. Le altezze dei punti d'urto sono corrispondenti e i danni riscontrati sui veicoli avversari fra loro compatibili.
                    * **Osservazioni:**
                    `
                }
              ]
            }
          ]
      },
      {
        "macro_section_id":
          "Danneggiato: MERLINO GABRIELE",
        "data":
          [
            {
              "section_id": "SEZIONE 4: Descrizione del fatto e relative conseguenze",
              "data": [
                {
                  "subsection_id": "Certificati di Pronto Soccorso",
                  "attributes": {
                    "documents": [
                      {
                        "original_document_type": "certificati_medici",
                        "ged_protocol": "GGLMS000000469549273"
                      }
                    ]
                  },
                  "data": "### Verbale di pronto soccorso 1\n**Paziente**: MERLINO GABRIELE MRLGRL73P07D969Z\n- **Data e ora accettazione**: 21/07/2024 13:13\n- **Codice Urgenza di accesso**: verde\n- **Data e ora dimissione**: 21/07/2024 16:12\n- **Codice d’urgenza di uscita**: verde\n- **Diagnosi**: CERVICALGIA\n- **Prognosi**: 7"
                }
              ]
            }
          ]
      },
      {
        "macro_section_id":
          "Danneggiato: WANNA KHAWLA",
        "data": [
          {
            "section_id": "SEZIONE 4: Descrizione del fatto e relative conseguenze",
            "data": [
              {
                "subsection_id": "Intervento legale",
                "attributes": {
                  "documents": [
                    {
                      "original_document_type": "intervento_legale",
                      "ged_protocol": "GGLMS000000465554355"
                    },
                    {
                      "original_document_type": "intervento_legale",
                      "ged_protocol": "GGLMS000000465554361"
                    },
                    {
                      "original_document_type": "intervento_legale",
                      "ged_protocol": "GGLMS000000465568619"
                    },
                    {
                      "original_document_type": "intervento_legale",
                      "ged_protocol": "GGLMS000000465568638"
                    },
                    {
                      "original_document_type": "intervento_legale",
                      "ged_protocol": "GGLMS000000465818578"
                    },
                    {
                      "original_document_type": "intervento_legale",
                      "ged_protocol": "GGLMS000000465818589"
                    },
                    {
                      "original_document_type": "intervento_legale",
                      "ged_protocol": "GGLMS000000466769686"
                    }
                  ]
                },
                "data": "### Intervento Legale 1\n\n•\t**Data documento** : 29/07/2024\n\n•\t**Avvocato** : Avv. Daniele Maranò\n\n•\t**Oggetto** : Numero sinistro: 005TG72024000040065 del 21.07.2024\n\n•\t**Contenuto** : In data 21.07.2024, all'incrocio tra la contrada cardinale e la SP 136 (Manduria-Maruggio), una Nissan Micra (targa CL 747 YM), ferma allo stop per dare precedenza, è stata tamponata da una Lancia Musa (targa DD004XM). La signora Khawla Wanna era a bordo della Nissan Micra come proprietaria e trasportata, assicurata con Generali Ass.ni Spa. Anche Gabriele Merlino era a bordo come conducente, assicurato con Generali Ass.ni Spa. Marita Silivestro era la conducente e proprietaria della Lancia Musa, assicurata con Great Lakes. Non c'è stato accesso al pronto soccorso, ma ci sono stati feriti non gravi. Si richiede una somma di denaro.\n\n### Intervento Legale 2\n\n•\t**Data documento** : 30/07/2024\n\n•\t**Avvocato** : Avv. Daniele Maranò\n\n•\t**Oggetto** : Messa in mora sinistro del 21.07.2024 terzo trasportato\n\n•\t**Contenuto** : Si tratta di una messa in mora relativa al sinistro del 21.07.2024, riguardante Wanna Khawla, terza trasportata. Le targhe dei veicoli coinvolti sono CL747YM e DD004XM. Wanna Khawla è indicata come contraente trasportato, Merlino Gabriele come conducente non contraente, e Silivestro Marita come conducente contraente della controparte e contraente non conducente di controparte non trasportato.\n\n### Intervento Legale 3\n\n•\t**Data documento** : 02/08/2024\n\n•\t**Avvocato** : Daniele Marano\n\n•\t**Oggetto** : Proposta e accettazione risarcimento danni materiali\n\n•\t**Contenuto** : Si tratta di una proposta e accettazione di risarcimento danni materiali relativi a un evento provocato dal veicolo con targa DD 004 XM. Wanna Khawla è l'assicurato e contraente trasportato con GENERALI ITALIA S.P.A., mentre Silvestro Marta è la controparte e conducente. L'importo richiesto è di € 1.700,00.\n\n"
              }
            ]
          },
          {
            "section_id": "SEZIONE 6: Principali accertamenti effettuati sulla quantificazione dei danni",
            "data": [
              {
                "subsection_id": "Perizia medico legale",
                "attributes": {
                  "documents": [
                    {
                      "original_document_type": "perizia_medico_legale",
                      "ged_protocol": "GGLMS000000474104396"
                    }
                  ]
                },
                "data": "\\n|||\\n|---|---|\\n| **Data affido incarico** | 28/10/2024 |\\n| **Data effettazione incarico** | 04/11/2024 |\\n| **Data trasmissione incarico** | 07/11/2024 |\\n| **Nominativo del medico** | BRUNETTI |\\n| **Nominativo del paziente** | WANNA KHAWLA |\\n| **Codice fiscale del paziente** | WNNKWL89T70Z352I |\\n| **Nesso causale evento** | Si |\\n| **Nesso causale menomazioni evento** | Si |\\n| **Utilizzo presidio sicurezza obbligatorie** | Si |\\n| **Lesioni stabilizzate** | Si |\\n| **VALUTAZIONE MEDICA DEL FIDUCIARIO**, cella \"INABILITA' TEMPORANEA BIOLOGICA - giorni\" | 0, 7, 20, 20 |\\n| **VALUTAZIONE MEDICA DEL FIDUCIARIO**: I.P. Biologica | 0.00 |\\n| **valutazione medica di controparte**, cella \"INABILITA' TEMPORANEA BIOLOGICA - giorni\"  | 7, 0, 87, 0 |\\n| **valutazione medica di controparte**:  I.P. Biologica | 3.00 | <br>\\n\\n\\n**Spese mediche congrue**:\\n- Farmacologiche: 116.18\\n- Specialistiche - Altro: 210.0\\n- Diagnostica -: 100.0\\n- Fisioterapiche - Altro: 112.0\\n- Diagnostica -: 50.0\\n- Diagnostica -: 112.0\\n- Fisioterapiche - Chiropratica: 315.0\\n- Altre cure mediche -: 20.0  <br>\\n\\n\\n**Spese mediche non congrue**:\\n- Specialistiche - Altro: 121.0  <br>\\n\\n\\n**Spese mediche non valutabili**:\\n- Spese di cura non valutabili per assenza di idonea documentazione fiscale: 0.0\\n- Spese di perizia medico legale: 0.0\\n- Spese per certificazioni ad uso assicurativo: 0.0  <br>\\n\\n\\n**Diagnosi**:\\nCERVICALGIA IN ASSENZA DI LESIONI STRUMENTALMENTE APPREZZABILI. <br>"
              },
              {
                "subsection_id": "Perizia auto",
                "attributes":
                  {
                    "documents":
                      [
                        {
                          "original_document_type": "perizia_auto",
                          "ged_protocol": "GGLMS000000466769662"
                        }
                      ]
                  }
                ,
                "data":
                  "\\n|||\\n|---|---|\\n| Data incarico | 23/07/2024 |\\n| Nominativo | KHAWLA WANNA |\\n| Certificato di proprietà | VVANNA KHAWLA - LOC. MONACO - 74020 - MARUGGIO - TA  C.Fisc/P.Iva: WNNKWL89T70Z3821 Tel: 3495243975 |\\n| Locatario |  |\\n| Coerenza del danno con dinamica del sinistro | si |\\n| Valore Commerciale | 2.050,00 |\\n| Valore Relitto | 0,00 |\\n| Tipo veicolo | NISSAN - MICRA (K12E) (11/02>05/06<) 1.0 16V Ber. |\\n| Targa | CL747YM |\\n| Immatricolazione | 03/12/2003 |\\n| Cifra concordata | 1.700,00 |\\n| Stato delle riparazioni | da iniziare |\\n| Riparazione antieconomica | No |\\n| Fermo tecnico | 4 |\\n| Importo richiesto | 2.500,00 |\\n| Imponibile | 1.538,43 |\\n| Imponibile + iva | 1.876,88 |\\n\\n* **Voci di danno e note:** Portello post. Rivestimento post. Traversa paraurti post. Paraurti post. Smalt. Rifiuti (0,00%) su Imponibile Totale Ancoraggio scocca su banco NOTE E DINAMICA RIFERITA DAASS.TO: Veicolo danneggiante tampona veicolo Nissan Micra oggetto di stima. Assicurato riferisce che trattasi di tamponamento con lesioni al conducente ed al trasportato. Concordati i danni alle cose al meglio in Euro 1.700,00 con il legale incaricato dall'assicurato (oltre suoi compensi) il quale rifiuta categoricamente qualsiasi applicazione di concorsualità. Si allega accettazione effettuata via ‘Whats-App dall'avv. Daniele Marano'. REPORT B-BOX: crash non registrato, ok geolocalizzazione (veicolo rimasto sul luogo dell'evento con il motore acceso dalle 12:00 alle 12:02)\\n* **Osservazioni:** CONCORDATO CON STU.LEG.DANIELE MARANOVIA UGO DE CAROLIS,113 74121 TARANTO  TEL.0997350518 IN E.1.700,00 OLTRE LEONI ED ONORARI,DA QUANTIFICARE.  TAMPONAMENTO. ASS.TO RIFIUTA CONCORSUALITA'. IBAN:NN.  [M.CONTINANZA RNPA  5150]\\n"
              }
              ,
              {
                "subsection_id": "Perizia riscontro",
                "attributes":
                  {
                    "documents":
                      [
                        {
                          "original_document_type": "perizia_riscontro",
                          "ged_protocol": "GGLMS000000467895682"
                        }
                      ]
                  }
                ,
                "data":
                  "\\n|||\\n|---|---|\\n| Data incarico | 31/07/2024 |\\n| Nominativo | KHAWLA WANNA |\\n| Certificato di proprietà | LIVESTRO MARITA - Via CAP. DE TOMMASO, 13 - 72024 - ORIA - BR  C.Fisc/P.Iva: SLIV/MRT83R70F152V Tel: non fornito |\\n| Locatario |  |\\n| Coerenza del danno con dinamica del sinistro | si |\\n| Valore Commerciale | 2.500,00 |\\n| Valore Relitto | 0,00 |\\n| Tipo veicolo | LANCIA MUSA (TG) (07/04>06/08<) 1.3MJ 16V (66Kw) Mnv 5p/d/1248cc (MNV-5p-1248 |\\n| Targa | CL747YM |\\n| Immatricolazione | 21/07/2006 |\\n| Cifra concordata | NON CONCORDATO |\\n| Stato delle riparazioni | DA INIZIARE |\\n| Riparazione antieconomica | No |\\n| Fermo tecnico | 0 |\\n| Importo richiesto | 0,00 |\\n| Imponibile | 0,00 |\\n| Imponibile + iva | 0,00 |\\n\\n* **Voci di danno e note:** In allegato le foto del veicolo della cpte che presenta danni nella parte anteriore. Nello specifico si nota la rottura del paraurti anteriore, della griglia anteriore inferiore e della modanatura anteriore. li cofano anteriore è bloccato, non si apre. In merito alla dinamica la cpte ha riferito di non aver tamponato il veicolo garantito ma che è stato quest'ultimo a urtare il suo in manovra di retromarcia. Pertanto, tramite il proprio legale di fiducia, ha inoltrato richiesta danni alla propria compagnia di assicurazioni Le altezze dei punti d'urto sono corrispondenti i e i danni riscontrati sui veicoli avversari fra loro compatibili.\\n* **Osservazioni:**\\n"
              }
            ]
          },
          {
            "section_id":
              "SEZIONE 7: Documentazione non associata a posizioni di danno esistenti",
            "data":
              [
                {
                  "subsection_id": "",
                  "attributes": {
                    "documents": [
                      {
                        "original_document_type": "intervento_legale",
                        "ged_protocol": "GGLMS000000465568636"
                      },
                      {
                        "original_document_type": "intervento_legale",
                        "ged_protocol": "GGLMS000000465681340"
                      },
                      {
                        "original_document_type": "intervento_legale",
                        "ged_protocol": "GGLMS000000465554363"
                      }
                    ]
                  },
                  "data": ""
                }
              ]
          }
        ]
      }
    ],
    "user_id": "anonymous"
  })
}

@Injectable({
  providedIn: 'root'
})
export class SmartSummaryApiService {
  readonly BASE_URL = environment.baseUrl;

  constructor(private httpClient: HttpClient,
              private messagesService: MessagesService) {
  }

  public async getLastCalls(): Promise<any[]> {
    try {
      return await firstValueFrom(this.httpClient.get<any>(`${this.BASE_URL}/api/smart-summary-last-calls`));
    } catch (error) {
      this.messagesService.addMessage({text: "Errore durante recupero ultime interrogazioni", type: "error"});
      throw error;
    }
  }

  public async getSmartSummary(numSinistro?: string, smartSummaryId?: string): Promise<any> {
    try {
      return new Promise(resolve => resolve(RESPONSE));
      // let httpParams = new HttpParams();
      // if (numSinistro) httpParams = httpParams.append('idSinistro', numSinistro);
      // if (smartSummaryId) httpParams = httpParams.append('smartSummaryId', smartSummaryId);
      // return await firstValueFrom(this.httpClient.get<any>(`${this.BASE_URL}/api/smart-summary`, {params: httpParams}));
    } catch (error) {
      this.messagesService.addMessage({text: "Errore durante recupero documento", type: "error"});
      return null;
    }
  }

  public async sendSmartSummaryFeedback(polliceSu: boolean, stelle: number | undefined, commento: string | undefined, idSinistro: string, smartSummaryId: string): Promise<any> {
    return await firstValueFrom(this.httpClient.post<any>(`${this.BASE_URL}/api/send-smart-summary-feedback`, {
      polliceSu,
      stelle,
      commento,
      idSinistro,
      smartSummaryId
    }));
  }

  public async downloadSmartSummaryDocument(gedProtocol: string, smartSummaryId: string): Promise<any> {
    try {
      return await firstValueFrom(this.httpClient.get(`${this.BASE_URL}/api/download-smart-summary-document`, {
        params: new HttpParams().set('gedProtocol', gedProtocol).set('smartSummaryId', smartSummaryId),
        responseType: 'json'
      }));
    } catch (error) {
      console.error("Errore durante il download del documento:", error);
      throw error;
    }
  }


}
